import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupNamesPipe'
})
export class GroupNamesPipePipe implements PipeTransform {

  transform(group: string) {

      
    let siteName =group.slice(5);
    let group_ = group.slice(6);
    // let groupsite = group.slice(11)

    if(siteName.includes('SiteManager')){
    
         siteName = siteName.substring(0, siteName.length - 12);
    }
 

    if(group == "ALFRESCO_ADMINISTRATORS"){
        return "Administrateur";
    }else if(group == "ALFRESCO_MODEL_ADMINISTRATORS" || group == "ALFRESCO_SEARCH_ADMINISTRATORS" || group == "site_" + siteName || group == "EMAIL_CONTRIBUTORS"){
         return
    }else if (group == "SITE_ADMINISTRATORS"){
        return  "Administrateur du site"
    }else if(group == "site_" + siteName + "_SiteManager"){
        return "Manager de " + siteName;
    }else if(group == "site_" + siteName + "_SiteConsumer"){
        return "Consommateur de " + siteName;
    }else if(group == "site_" + siteName + "_SiteCollaborator"){
        return "Collaborateur de " + siteName;
    }else if(group == "site_" + siteName + "_SiteContributor"){
        return "Contributeur de " + siteName;
    }else if(group == "GROUP_" + group_){
        return group_
    }else{
        return group;
    }
    
}

}
